import creatorIcon from "../../asset/Home/contentCreater.svg";
import studentIcon from "../../asset/Home/student.svg";
import busyIcon from "../../asset/Home/busyIndividuals.svg";
import translatorIcon from "../../asset/Home/translator.svg";
import professionalIcon from "../../asset/Home/professionals.svg";
import chatCard from "../../asset/Home/trainerChat.svg";
import circleGif from "../../asset/Home/circleFeature.gif";
import waveform from "../../asset/Home/waveForm.svg";
import playAI from "../../asset/Home/playAI.svg";
import teacherBg from "../../asset/Home/teacherBg.svg";
import { useNavigate } from "react-router-dom";
function UseCases() {
  const navigate = useNavigate();

  const goToSection = (id) => {
    navigate("/", {
      state: {
        scrollTo: id,
      },
    });
  };

  return (
    // <section className="py-24 px-6" style={{ zoom: "0.77" }}>
    <section
      className="
		py-14
		md:py-17
		md:px-17
		lg:py-30

		px-4
		sm:px-6
	"
      style={{ zoom: "0.77" }}
    >
      <div className="max-w-[1440px] mx-auto">
        <div
          className="
		grid
		grid-cols-1
		md:grid-cols-2
		xl:flex
		xl:flex-row

		gap-6
		items-start
	"
        >
          {/* LEFT COLUMN - Title + Busy Individual */}
          <div
            className="
		w-full
		flex
		flex-col
		gap-6
		xl:w-[500px]
	"
          >
            {/* Title Section */}
            <div
              className="
    flex
    flex-col

    items-center
    lg:items-start

    text-center
    lg:text-left
  "
            >
              <span className="inline-block bg-[#FFE4DE] -mt-10 text-[#E8604A] font-prompt font-semibold text-lg px-2 py-1 rounded-md">
                Use Cases
              </span>

              <h2
                className="
    

    font-prompt
    font-bold
    mt-10
    text-[#46453D]

    text-[42px]
    sm:text-[50px]
    lg:text-[58px]

    leading-[1]

    text-center
    lg:text-left
  "
              >
                {" "}
                Power Voice
                <br />
                across Industries
              </h2>

              <p
                className="
    mt-5
    text-[#555]
    font-jakarta
    text-[16px]
    leading-[1.8]

    max-w-[350px]

    mx-auto
    lg:mx-0
  "
              >
                {" "}
                Build AI voice agents for sales, recruitment, customer success,
                employee training, content creation, and more. With Craft Your
                Agent, you can train AI agents on your business knowledge, clone
                your voice, and automate natural, human-like conversations and
                content creation at scale.
              </p>

              <button
                onClick={() => goToSection("live-demo")}
                className="
    mt-5

    bg-[#36332F]
    text-white
    font-semibold

    h-[60px]
    w-[180px]

    rounded-lg

    mx-auto
    lg:mx-0
  "
              >
                {" "}
                Live Demo
              </button>
            </div>

            {/* Busy Individual Card */}
            <div
              className="bg-[#FBFBFB]
border
border-[#DDD7D4]
rounded-[16px]

p-6

h-auto
min-h-[250px]

transition-all
duration-300

hover:-translate-y-2
hover:shadow-xl"
            >
              {/* <img src={busyIcon} alt="" className="w-[54px] h-[54px]" />
              <h3 className="mt-6 font-prompt font-bold text-[20px] leading-none text-[#46453D]">
                Busy Individual
              </h3> */}
              <img
                src={busyIcon}
                alt=""
                className="
    w-[54px]
    h-[54px]

    mx-auto
    sm:mx-0
  "
              />

              <h3
                className="
    mt-6

    text-center
    sm:text-left

    font-prompt
    font-bold
    text-[20px]
    leading-none
    text-[#46453D]
  "
              >
               Sales Teams
              </h3>
              <p className="mt-3 text-[#666] font-jakarta text-[17px] leading-[1.6]">
               Qualify leads, handle objections, provide instant solutions, and book more meetings with AI sales expert agents that answer instantly.
              </p>
            </div>
          </div>

          {/* MIDDLE COLUMN - Content Creator + Translator */}
          <div
            className="
		w-full
		flex
		flex-col
		gap-6

		mt-0
		xl:w-[330px]
		xl:mt-[150px]
	"
          >
            {/* Content Creator Card */}
            <div
              className="
	bg-[#FBFBFB]
	border
	border-[#DDD7D4]
	rounded-[16px]

	p-6

	h-auto
	min-h-[270px]

	transition-all
	duration-300

	hover:-translate-y-2
	hover:shadow-xl
"
            >
              <img
                src={creatorIcon}
                alt=""
                className="
    w-[54px]
    h-[54px]

    mx-auto
    sm:mx-0
  "
              />
              <h3
                className="
    mt-6

    text-center
    sm:text-left

    font-prompt
    font-bold
    text-[20px]
    leading-none
    text-[#46453D]
  "
              >
                {" "}
HR & Recruitment
              </h3>
              <p className="mt-3 font-jakarta text-[#666] text-[17px] leading-[1.7]">
                Screen candidates, conduct first-round interviews, and generate hiring insights to identify the best talent faster.
              </p>
            </div>

            {/* Translator Card */}
            <div
              className="
	bg-[#FBFBFB]
	border
	border-[#DDD7D4]
	rounded-[16px]

	p-6

	h-auto
	min-h-[270px]

	transition-all
	duration-300

	hover:-translate-y-2
	hover:shadow-xl
"
            >
              <img
                src={translatorIcon}
                alt=""
                className="w-[54px] h-[54px] mx-auto sm:mx-0"
              />
              <h3
                className="
    mt-6

    text-center
    sm:text-left

    font-prompt
    font-bold
    text-[20px]
    leading-none
    text-[#46453D]
  "
              >
                {" "}
                Content Creators
              </h3>
              <p className="mt-3 text-[#666] font-jakarta text-[17px] leading-[1.8]">
               Clone your own voice to create content, narrations, and personalized experiences without recording every time.
              </p>
            </div>
          </div>

          {/* RIGHT COLUMN - Students + Professionals */}
          <div
            className="
		w-full

		md:col-span-2

		grid
		grid-cols-1
		md:grid-cols-2

		gap-6

		xl:flex
		xl:flex-col
		xl:flex-1
	"
          >
            {/* Students Card */}
            <div
              className="
		bg-[#FBFBFB]
		border
		border-[#DDD7D4]
		rounded-[16px]

		p-6

		h-auto
		md:min-h-[300px]
		xl:h-[355px]

		relative
		overflow-hidden
	"
            >
              {" "}
              <div
                className="
		flex
		flex-col
		lg:flex-row

		gap-6
		h-full
	"
              >
                {/* Left side - Text */}
                <div
                  className="
    w-full
    lg:w-[40%]

    flex
    flex-col

    items-center
    sm:items-start
  "
                >
                  <img src={studentIcon} alt="" className="w-[54px] h-[54px]" />
                  <h3
                    className="
						mt-6

						text-center
						sm:text-left

						font-prompt
						font-bold
						text-[20px]
						leading-none
						text-[#46453D]
					"
                  >
                    {" "}
                  Customer Success
                  </h3>
                  <p className="mt-3 text-[#666] font-jakarta text-[16px] leading-[1.6]">
                  Deliver instant, personalized support in 50+ languages, resolve customer queries 24/7, and keep customers engaged with human-like AI conversations.
                  </p>
                </div>

                {/* Right side - Teacher Chat */}
                <div
                  className="w-full
lg:w-[60%] relative"
                >
                  {/* TEXT FIRST */}
                  <div className="relative z-10">
                    <div className="flex items-center gap-2">
                      <img
                        src="https://i.pravatar.cc/150?img=5"
                        alt=""
                        className="w-8 h-8 rounded-full object-cover"
                      />

                      <h4 className="font-bold text-[15px] text-[#46453D]">
                        Emma (Customer)
                      </h4>
                    </div>

                    <p
                      className="
        mt-4
        text-[16px]
        leading-[1.8]
        text-[#666]
      "
                    >
                      <br/>
              <strong>Emma:</strong>        Hi, I haven't received my order yet. Can you help?
<br/>

<strong>AI agent:</strong> Your order is in transit and will arrive tomorrow.
                    </p>
                  </div>

                  {/* BG IMAGE */}
                  <img
                    src={teacherBg}
                    alt=""
                    className="
    absolute
    left-0
    bottom-[-23px]
    w-full
    z-20
    pointer-events-none
  "
                  />

                  {/* AUDIO BOX */}
                  <div
                    className="
    absolute
    left-0
    right-0
    bottom-0
    z-30

    bg-white
    border
    border-[#EEE9E6]

    rounded-md
    h-[54px]

    flex
    items-center
    px-3

    shadow-sm
  "
                  >
                    <div
                      className="
    relative
    w-8
    h-8
    shrink-0
  "
                    >
                      <img
                        src={circleGif}
                        alt=""
                        className="
      w-full
      h-full
      rounded-full
      object-cover
    "
                      />

                      <img
                        src={playAI}
                        alt=""
                        className="
      absolute
      inset-0
      m-auto

      w-4
      h-4

      z-10
    "
                      />
                    </div>

                    <span className="ml-3 text-[11px] text-[#9C9C9C]">
                     Your order is in transit and will arrive tomorrow.
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* Professionals Card */}
            <div
              className="
		bg-[#FBFBFB]
		border
		border-[#DDD7D4]
		rounded-[16px]

		 md:-mt-[160px]
		lg:-mt-[120px]
		xl:mt-0

		p-6

		h-auto
md:min-h-[240px]
xl:h-[350px]

		relative
		overflow-hidden
	"
            >
              <div
                className="
		flex
		flex-col
		lg:flex-row

		gap-6
		h-full
	"
              >
                {/* Left side - Text */}
                <div
                  className="
    w-full
    lg:w-[47%]

    flex
    flex-col

    items-center
    sm:items-start
  "
                >
                  <img
                    src={professionalIcon}
                    alt=""
                    className="
    w-[54px]
    h-[54px]
			
    mx-auto
    sm:mx-0
  "
                  />
                  <h3
                    className="
    mt-5

    text-center
    sm:text-left

    font-prompt
    font-bold
    text-[20px]
    text-[#46453D]
  "
                  >
                    {" "}
                    Employee Training

                  </h3>
                  <p className="mt-3 text-[17px] leading-[1.6] font-jakarta text-[#666]">
                Train AI on your company knowledge and let it onboard, guide, and train employees anytime, without a trainer.
                  </p>
                </div>

                {/* Right side - Voice + Chat */}
                <div
                  className="
    w-full
    lg:w-[79%]

    relative

    min-h-[220px]
    sm:min-h-[260px]
    lg:min-h-0
  "
                >
                  {/* Voice Widget */}
                  <div
                    className="
    absolute
    top-0
    right-0

    w-full
    sm:w-[260px]

    h-[44px]
	md:h-[50px]
	md:w-[360px]

    bg-white
    border
    border-[#ECE7E4]

    rounded-[7px]

    flex
    items-center

    px-2

    shadow-sm

    z-20

    animate-[pulse_4s_ease-in-out_infinite]
  "
                  >
                    <div
                      className="
    relative

    w-7
    h-7
	md:w-10
    md:h-10

    rounded-full
    overflow-hidden
    shrink-0
  "
                    >
                      <img
                        src={circleGif}
                        alt=""
                        className="
      w-full
      h-full
      object-cover
    "
                      />

                      <img
                        src={playAI}
                        alt=""
                        className="
      absolute
      inset-0

      m-auto

      w-3.5
      h-3.5
	   md:w-7.5
      md:h-7.5

      z-10
    "
                      />
                    </div>

                    <img
                      src={waveform}
                      alt=""
                      className="
  -ml-6
  md:-ml-8
  lg:-ml-10

  flex-1
  h-[19px]
  md:h-[27px]
  object-contain
"
                    />
                  </div>

                  {/* Chat Card */}
                  <img
                    src={chatCard}
                    alt=""
                    className="
    absolute

    top-[-50px]
    lg:top-[-26px]

    left-0

    w-full

    transition-transform
    duration-500

    group-hover:scale-[1.02]
  "
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default UseCases;
